import { render, staticRenderFns } from "./terms-of-serivce.vue?vue&type=template&id=9548092c&"
import script from "./terms-of-serivce.vue?vue&type=script&lang=js&"
export * from "./terms-of-serivce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports